// src/services/analyticsService.js
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api'; 


const getAuthHeaders = (walletAddress) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  if (walletAddress) {
    headers['x-wallet-address'] = walletAddress;
  }
  return headers;
};

const handleApiResponse = async (response) => {
  if (!response.ok) {
    let errorData;
    try {
      errorData = await response.json();
    } catch (e) {
      errorData = { message: response.statusText || `HTTP error! status: ${response.status}` };
    }
    console.error("API Error Response:", errorData);
    throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
  }
  if (response.status === 204) {
    return null;
  }
  return response.json();
};

export const analyzeTokenData = async (
  tokenAddress,
  chainId,
  analysisTypes = [],
  pairAddressForAnalysis = null,
  userWalletAddress = null 
) => {
  if (!API_BASE_URL) {
    console.error("Backend API base URL is not configured.");
    throw new Error("API endpoint not configured.");
  }
  
  const endpoint = `${API_BASE_URL}/analytics/analyze-token`;
  const payload = {
    tokenAddress,
    chainId,
    analysisTypes,
    pairAddress: pairAddressForAnalysis,
  };


  try {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: getAuthHeaders(userWalletAddress),
      body: JSON.stringify(payload),
    });
    return await handleApiResponse(response); 
  } catch (error) {
    console.error(`[AnalyticsService FE] Error calling analyzeTokenData API:`, error.message);
    throw error; 
  }
};
